<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0">Motorbikes</h3>
        </b-card-header>

        <el-table class="table-responsive table"
                  header-row-class-name="thead-light"
                  header-cell-class-name="px-1"
                  cell-class-name="px-1 pointer"
                  table-layout="auto"
                  size="small"
                  fit
                  highlight-current-row
                  @current-change="onSelect"
                  :data="motorbikes">
            <el-table-column label="Brand"
                             prop="name">
                <template v-slot="{row}">
                    <b-media no-body class="align-items-center">
                        <a href="#" class="avatar rounded-circle mr-3" v-if="row.img">
                            <img alt="Image placeholder" :src="row.img">
                        </a>
                        <b-media-body>
                            <!-- <span class="font-weight-600 name mb-0 text-sm">{{row.brand}}</span> -->
                            <!-- <router-link :to="{ name:'motorbike', params: {id: row.id} }">{{row.brand}}</router-link> -->
                            {{row.brand}}
                        </b-media-body>
                    </b-media>
                </template>
            </el-table-column>
            <el-table-column label="Model"
                             prop="model">
            </el-table-column>

            <el-table-column label="Licenseplate"
                             prop="licenseplate">
            </el-table-column>
        </el-table>

        <!-- TODO: implement pagination -->
        <!-- <b-card-footer class="py-4 d-flex justify-content-end">
            <base-pagination v-model="currentPage" :per-page="10" :total="50"></base-pagination>
        </b-card-footer> -->
    </b-card>
</template>
<script>
  import { Table, TableColumn} from 'element-ui'
  import { mapGetters } from 'vuex';
  export default {
    name: 'motorbikes-table',
    components: {
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    // data() {
    //   return {
    //     currentPage: 1
    //   };
    // },
    computed: {
      ...mapGetters({
        motorbikes: 'motorbikes/motorbikes'
      })
    },
    methods: {
      onSelect(newValue) {
        this.$router.push({name: 'motorbike', params: {id: newValue._id}})
      }
    }
  }
</script>
